import { Icon } from "source/shared/components/Icon"

export function PaymentSecurityDisclaimer() {
  return (
    <div className="d-f ai-fs fs-5 c-tint3 g-4p">
      <span>
        <Icon symbol="general#lock" aria-hidden />
      </span>
      <p className="m-0">
        Your payment is processed securely by{" "}
        <a href="//stripe.com/" target="_blank" rel="noopener noreferrer">
          Stripe
        </a>
        .
      </p>
    </div>
  )
}
